import React from 'react'
import PropTypes from 'prop-types'

const Restricted = (props) => {
  return (
    <div className="ui-restricted" onClick={() => props.setModal('LoginModal')}>
      <p>Please <a>log in</a> to view {props.section}</p>
    </div>
  )
}

Restricted.propTypes = {
  section: PropTypes.string,
  setModal: PropTypes.func
}

Restricted.defaultProps = {
  section: '',
  setModal: function() {}
}

export default Restricted



// WEBPACK FOOTER //
// ./src/components/common/restricted.js